import { render } from "./tcshoptypeManage.vue?vue&type=template&id=6c3c8cfa"
import script from "./tcshoptypeManage.vue?vue&type=script&lang=jsx"
export * from "./tcshoptypeManage.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__